import {
  Alert,
  AlertIcon,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

interface Reset2FAModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  userEmail: string;
}

export const Reset2FAModal: React.FC<Reset2FAModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  userEmail,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={!isLoading}>
      <ModalOverlay />
      <ModalContent px={3} py={3}>
        <ModalHeader>Reset Two-Factor Authentication</ModalHeader>
        <ModalCloseButton disabled={isLoading} />

        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text>
              Are you sure you want to reset 2FA for <strong>{userEmail}</strong>?
            </Text>

            <Alert status="warning" borderRadius="md">
              <AlertIcon />
              <VStack align="start" spacing={1}>
                <Text fontWeight="bold" fontSize="sm">
                  This action will:
                </Text>
                <Text fontSize="sm">• Remove all authenticator devices</Text>
                <Text fontSize="sm">• Invalidate all recovery codes</Text>
                <Text fontSize="sm">• Send an email notification to the user</Text>
              </VStack>
            </Alert>

            <Text fontSize="sm">The user will need to set up 2FA again on their next login.</Text>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="outline"
            colorScheme="black"
            _hover={{ opacity: 0.5 }}
            mr={3}
            onClick={onClose}
            isDisabled={isLoading}
          >
            Cancel
          </Button>
          <Button colorScheme="red" onClick={onConfirm} isLoading={isLoading} fontWeight="bold">
            Reset 2FA
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
